'use strict';

var NotificationService = require('../services/notification-service');
var HTTPService = require('../services/http-service');
var Pace = require('./pace');

var WishList = {
  add: function add(params) {
    params = params || {};
    var me = blz.me || {};

    if (!me.email) {
      var pathName = `/minha-conta/entrar?nextPath=${
        params.url || location.pathname
      }?addToWishlist`;
      window.location.href = pathName;
      return;
    }

    Pace.open();

    var url = '/api/wish-list/' + params.sku;
    return HTTPService.post(url)
      .then(HTTPService.handleClientError)
      .then(function () {
        $(document).trigger('wishList:add-product', params);
      })
      .catch(NotificationService.warning)
      .always(Pace.close);
  }
};

function _addWishToList(event) {
  event.preventDefault();
  WishList.add($(this).data() || {});
  $(this).parent().addClass('on-wish-list');
}

function _shareWishList(event) {
  var data = $(this).data();
  var Native = window.Native || {};

  if (data.webview && Native.shareWishlist) {
    event.preventDefault();
    Native.shareWishlist(data.type);
  }
}

$('body').on('click tap', '.js-add-to-wish-list', _addWishToList);
$('body').on('click tap', '.js-wishlist-share', _shareWishList);

module.exports = WishList;
